<ng-container [formGroup]="model">
  <div class="menu">
    <mat-form-field libZalamoField>
      <mat-label>Układ</mat-label>
      <mat-select formControlName="size">
        @for (scene of scenes; track scene; let i = $index) {
          <mat-option [value]="scene.id">{{ scene.name }}</mat-option>
        }
      </mat-select>
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    <mat-form-field>
      <mat-label>Kolor</mat-label>
      <input
        [(colorPicker)]="textColor"
        [ngStyle]="{ backgroundColor: textColor }"
        cpOutputFormat="rgba"
        formControlName="color"
        matInput
    /></mat-form-field>
    @if (currentThickness$ | async) {
      <mat-form-field libZalamoField>
        <mat-label>Grubość</mat-label>
        <mat-select formControlName="thickness">
          <mat-option value="1"> Cienki</mat-option>
          <mat-option value="2"> gruby</mat-option>
        </mat-select>
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
    }
    @if (urls.controls.length > 1) {
      <lib-checkbox formControlName="spread">Tylko jedno zdjęcie </lib-checkbox>
    }
    <ng-container formArrayName="url">
      @for (control of urls.controls; track control; let i = $index) {
        @if ((model.value.spread && i === 0) || !model.value.spread) {
          <lib-single-file-uploader
            (uploadEnded)="uploadInProgress = uploadInProgress - 1"
            (uploadStarted)="uploadInProgress = uploadInProgress + 1"
            [contextId]="organizationService.getCurrentOrganization() | async"
            [formControlName]="i"
            context="LookBookPreview"
            ><label>zdjęcie {{ i + 1 }}</label>
          </lib-single-file-uploader>
        }
      }
    </ng-container>
    @if (loadingInProgress$ | async) {
      <mat-progress-bar mode="query"></mat-progress-bar>
    }
    @if (buffer) {
      <a [href]="buffer" download="wallart.jpg">
        <lib-button lg>Pobierz</lib-button>
      </a>
    }
  </div>
  <div class="preview">
    <img #preview />
  </div>
  <div class="views">
    @for (view of currentViews$ | async; track view) {
      <img
        (click)="model.patchValue({ view: view })"
        [ngClass]="{ active: this.model.value.view === view }"
        src="/assets/wallart/{{ model.value.size }}/{{ view }}.jpg"
      />
    }
  </div>
</ng-container>
